export default "__VITE_PUBLIC_ASSET__864ba34f__"